var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88235 12C3.88235 11.4902 4.29563 11.0769 4.80543 11.0769L11.0622 11.0769L11.0622 4.82015C11.0622 4.31035 11.4755 3.89707 11.9853 3.89707C12.4951 3.89707 12.9084 4.31035 12.9084 4.82015L12.9084 11.0769H19.1651C19.6749 11.0769 20.0882 11.4902 20.0882 12C20.0882 12.5098 19.6749 12.9231 19.1651 12.9231H12.9084L12.9084 19.1799C12.9084 19.6897 12.4951 20.1029 11.9853 20.1029C11.4755 20.1029 11.0622 19.6897 11.0622 19.1799L11.0622 12.9231L4.80543 12.9231C4.29563 12.9231 3.88235 12.5098 3.88235 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2c6fb7e4e9bb15532fbca18f4f55adf8.svg";
export { ForwardRef as ReactComponent };